module.exports = __webpack_public_path__ + "static/media/svg-logo.49a7b31d.svg";